import { h } from 'vue';
var script = {
  props: {
    story: {
      type: Object,
      required: true
    }
  },
  render() {
    const style = {
      width: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
      margin: 'auto'
    };
    const params = {
      style,
      domProps: {
        src: this.story.url
      }
    };
    return h('img', params);
  }
};
export { script as default };